import styled from "styled-components";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";

export const SwiperContainer = styled.div`
  height:100vh;
  width: 100vw;
  cursor: ${({ cursor, fontColor }) =>
    isMobile
      ? "initial" : cursor === 1 ? fontColor==="white" ? "url(left_white_arrow.png), auto" : "url(left_black_arrow.png), auto"
      : cursor === 2 ? fontColor==="white" ? "url(right_white.png), auto" : "url(right_black_arrow.png), auto"
      : "none"};
    @media screen and (max-width: 1080px) {
  }
`;

export const ImgWrap = styled.div`
  height:100vh;
  width: 100vw;
`;

export const Img = styled.img`  
  width:100%;
  height:100%;
  object-fit:cover;

`;


export const Video = styled.video`  
  width:100%;
  height:100%;
  object-fit:cover;

`;

export const ImgSubtitle = styled.div`
  font-size: 20px;
  color: ${({index}) => index===39 || (isMobile && index===16) ? "#ffffff" :((index === 36 && isMobile) || (index===29 && !isMobile)) ? "#000000" : "inherit"};
  position: absolute;
  right:${() => isMobileOnly ? "7vw" : isTablet ? "5.5vw" : "4vw"};
  top: ${({vhScreen}) => isMobileOnly ? vhScreen : isTablet ? "90vh" : "94vh"};
  
  white-space: nowrap;
  @media screen and (max-width: 575px) {
    font-size: 15px;
  }
`;
